/**
 * Game formats organized by sport
 * Used as fallback when API is unavailable
 */

export const GAME_FORMATS = {
  Soccer: ['3v3', '4v4', '5v5', '6v6', '7v7', '8v8', '9v9', '11v11', 'Futsal'],
  Basketball: ['1v1', '2v2', '3v3', '4v4', '5v5'],
  Volleyball: ['2v2', '4v4', '6v6', 'Beach (2v2)'],
  Football: ['5v5', '6v6', '7v7', '8v8', '9v9', '11v11', 'Flag', 'Touch'],
  Baseball: ['9v9', 'T-Ball', 'Coach Pitch', 'Kid Pitch'],
  Tennis: ['Singles', 'Doubles', 'Mixed Doubles'],
  Swimming: ['Individual', 'Relay', 'Medley', 'Open Water'],
  Hockey: ['3v3', '4v4', '5v5', '6v6', 'Ice', 'Street', 'Field'],
  Rugby: ['7s', '10s', '15s', 'Touch', 'Tag'],
  Cricket: ['T20', 'ODI', 'Test', 'Indoor'],
  Lacrosse: ['6v6', '10v10', 'Box', 'Field'],
  Golf: ['Stroke Play', 'Match Play', 'Scramble', 'Best Ball'],
  Wrestling: ['Folkstyle', 'Freestyle', 'Greco-Roman'],
  Gymnastics: ['Artistic', 'Rhythmic', 'Trampoline', 'Acrobatic'],
  Track: ['Sprint', 'Distance', 'Field Events', 'Combined Events'],
  Other: ['Custom Format']
};

export const SPORTS_LIST = [
  'Soccer',
  'Basketball',
  'Volleyball',
  'Football',
  'Baseball',
  'Tennis',
  'Swimming',
  'Hockey',
  'Rugby',
  'Cricket',
  'Lacrosse',
  'Golf',
  'Wrestling',
  'Gymnastics',
  'Track',
  'Other'
];

export const REGISTRATION_STATUSES = [
  { value: 'open', label: 'Open', color: '#22c55e', icon: '🟢' },
  { value: 'closed', label: 'Closed', color: '#ef4444', icon: '🔴' },
  { value: 'coming_soon', label: 'Coming Soon', color: '#eab308', icon: '🟡' }
];

export const FEE_INTERVALS = [
  { value: 'Per Program', label: 'Per Program (One-time)' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Per Game', label: 'Per Game' }
];

export const DAYS_OF_WEEK = [
  { value: 'Monday', label: 'Mon', fullLabel: 'Monday' },
  { value: 'Tuesday', label: 'Tue', fullLabel: 'Tuesday' },
  { value: 'Wednesday', label: 'Wed', fullLabel: 'Wednesday' },
  { value: 'Thursday', label: 'Thu', fullLabel: 'Thursday' },
  { value: 'Friday', label: 'Fri', fullLabel: 'Friday' },
  { value: 'Saturday', label: 'Sat', fullLabel: 'Saturday' },
  { value: 'Sunday', label: 'Sun', fullLabel: 'Sunday' }
];

export const TIME_OPTIONS = (() => {
  const times = [];
  for (let h = 6; h <= 22; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hour = h % 12 || 12;
      const period = h < 12 ? 'AM' : 'PM';
      const label = `${hour}:${m.toString().padStart(2, '0')} ${period}`;
      const value = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
      times.push({ value, label });
    }
  }
  return times;
})();
